<script setup lang="ts">
import type { SiteBlockData, SiteBlockSettings } from '../../../types/site'

defineProps<{ data: SiteBlockData, settings: SiteBlockSettings, editing?: boolean }>()
</script>

<template>
  <figure v-if="data.url">
    <img
      :src="data.url"
      :alt="data.alt || ''"
      class="w-full rounded-[var(--site-radius)] object-cover"
      loading="lazy"
    >
    <figcaption
      v-if="data.caption"
      class="mt-2 text-center text-sm text-[var(--site-muted)]"
    >
      {{ data.caption }}
    </figcaption>
  </figure>
  <!-- No image yet: silent (as before) on the public page, a click target
       while building — see BlockFrame's `editing` doc comment. -->
  <div
    v-else-if="editing"
    class="flex flex-col items-center gap-2 rounded-[var(--site-radius)] border border-dashed border-[var(--site-border)] p-10 text-center text-sm text-[var(--site-muted)]"
  >
    <svg class="size-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <circle cx="8.5" cy="8.5" r="1.5" />
      <path d="m21 15-5-5L5 21" />
    </svg>
    <span>Upload or paste an image on the right to fill this in.</span>
  </div>
</template>
